export default "__VITE_ASSET__4d31814c__"